module.exports = __webpack_public_path__ + "LatoLatin-HeavyItalic.ab9f021a64ba0f1c130d.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-HeavyItalic.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-HeavyItalic.ttf
// module chunks = styles